import { ChakraBox as Box } from "@airhelp/react-ui-components";
import styles from "./Table.styles";
import type { TableProps } from "./Table.d";

const Table = ({ props: content = "" }: TableProps) => (
  <Box sx={styles} dangerouslySetInnerHTML={{ __html: content }} />
);

export default Table;
